import React from 'react';

export function InputInfo({error, type, placeholder = 'Ваш ответ', required = false, name, title, value, disabled, onChange, className = ''}) {

  return <div className={"info__form_input" + (className ? ' ' + className : '')}>
    <p>{title} {required && <span className="valid">*</span>}</p>
    {type === 'textarea' && <textarea name={name}
                                      className={(error ? "input--error" : "")}
                                      placeholder={placeholder}
                                      value={value}
                                      disabled={disabled}
                                      onChange={onChange}></textarea>}
    {type !== 'textarea' && <input type={type}
                                   name={name}
                                   className={(error ? "input--error" : "")}
                                   placeholder={placeholder}
                                   value={value}
                                   disabled={disabled}
                                   onChange={onChange}/>}
  </div>;
}
